import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export function ThemeToggle({ className = '', label = true }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === 'light';
  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
        isLight
          ? 'bg-yellow-50 border-yellow-200 text-yellow-900 hover:bg-yellow-100'
          : 'bg-white/5 border-white/10 text-[#A0B4CC] hover:bg-white/10 hover:text-white'
      } ${className}`}
      aria-label="Toggle color theme"
      data-testid="theme-toggle-btn"
    >
      {isLight ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {label && <span>{isLight ? 'Light' : 'Dark'} mode</span>}
    </button>
  );
}
